var App = function () {
    var init = function () {

        // $('.lazy').lazy();

        __handleMiPedido();
        __handleToolTip();
        __handleRulesMethodsValidation();
        __handleDatepicker();
        __handleBuscador();
        __handleMenuNav();
        __handleSearchClientes();
        __handleSession();

        $("img").error(function () {
            $(this).attr("src", $(this).data("alt-src"));
            $(this).parents("a.fancy").off().on('click', function () {
                return false;
            })
        })
    };

    var __handleBuscador = function () {
        if ($("div.buscador").length > 0) {
            var $familias1 = $("#search_codigo_familia_1");
            var $familias2 = $("#search_codigo_familia_2");
            $familias1.off('change').on('change', function () {
                __loadFamilias(1, $(this).val());
            });
            $familias2.off('change').on('change', function () {
                __loadFamilias(2, $(this).val());
            });

            $(".show-buscador").off("click").on("click", function (e) {
                e.preventDefault();
                var $divBuscador = $("div.buscador");
                var $divContainer = $("div.container", $divBuscador);
                var active = $divContainer.height() > 60;

                if (active) {
                    $divContainer.animate({
                        height: "54px"
                    });
                } else {
                    $divContainer.animate({
                        height: "285px"
                    });
                }
            });
        }
    };

    var __loadFamilias = function (source, codigo) {
        $.ajax({
            type:     "POST",
            url:      Globals.HOST_INTRANET + "/catalogo_act.php",
            data:     {
                accion: "chainFamilias",
                codigo: codigo
            },
            dataType: "json",
            success:  function (data) {
                if (data.success) {
                    var $target = $("#search_codigo_familia_" + (source + 1));
                    var label = "";
                    if (source == 1) {
                        label = "Familias";
                    } else if (source == 2) {
                        label = "Subfamilias";
                    }
                    var html = '<option value="">' + label + '</option>';
                    if (typeof data.options != "undefined") {
                        $.each(data.options, function (index, option) {
                            html += '<option value="' + option.codigo + '">' + option.nombre + '</option>';
                        });

                    }
                    $target.html(html);
                    $target.trigger('change');
                }
            }
        });
    };

    var __handleMiPedido = function () {
        $("div.blk-cart div.cart, .btnOpenCart").off("click").on("click", function (e) {
            e.preventDefault();
            $.ajax({
                type:     "POST",
                url:      Globals.HOST_INTRANET + "/pedidos_act.php",
                data:     {
                    accion: "miPedido"
                },
                dataType: "json",
                success:  function (json) {
                    if (json.success) {
                        var $modal_miPedido = $("#modal_miPedido");
                        if ($modal_miPedido.length > 0) {
                            $modal_miPedido.remove();
                        }
                        $(json.miPedido).appendTo("body").modal('show');
                        __handleToolTip();
                        handleFormPedido();
                        var codigos = [];
                        var codigo = '';
                        var cantidad = 1;
                        $("tr.productRow").each(function () {
                            codigo = $(this).data("codigo");
                            cantidad = $("input[name^='cantidad_']", $(this)).val();
                            codigos.push([codigo, cantidad]);
                        });
                        if (codigos.length > 0) {
                            if ($("input[name='id_estado']", $("form#fPedido")).val() == Globals.ESTADO_ABIERTO) {
                                obtenerNetos(codigos, true);
                            }
                        }
                    }
                }
            });
        });
    };

    var handleFormPedido = function () {
        var $form = $("form#fPedido");

        $form.validate({
            submitHandler: function (form) {
                $(form).ajaxSubmit({
                    dataType:   "json",
                    beforeSend: function () {
                        $("button", $(".modal-footer")).addClass("disabled");
                    },
                    error:      function () {
                        $("button", $(".modal-footer")).removeClass("disabled");
                    },
                    success:    function (json) {
                        if (json.success) {
                            var msg = "";
                            if (json.enviado) {
                                msg = "El pedido se ha enviado correctamente.";
                                setTimeout(function () {
                                    location.reload()
                                }, 5000);
                            } else if (json.eliminado) {
                                msg = "El pedido se ha eliminado correctamente.";
                                setTimeout(function () {
                                    location.reload()
                                }, 5000);
                            } else {
                                msg = "La información del pedido se ha guardado correctamente.";
                                $("button", $(".modal-footer")).removeClass("disabled");
                            }
                            __notifica({
                                status:  "success",
                                message: msg
                            })
                        } else {
                            __notifica({
                                status:  "danger",
                                message: "Ha ocurrido un error al guardar la información del pedido."
                            });
                            $("button", $(".modal-footer")).removeClass("disabled");
                        }
                    }
                });
            }
        });

        $("input[name^='cantidad_']").blur(function () {
            var id = $(this).attr("name").replace("cantidad_", "");
            var cantidad = $(this).val();
            var cantidadPrevia = $("input[name='precantidad_" + id + "']").val();
            if (cantidad != cantidadPrevia) {
                updatePedidoCantidad(id, cantidad);
            }
        });

        $("a.btnDelProd").off("click").on("click", function (e) {
            e.preventDefault();
            var id = $(this).parents("tr").data("id");
            __confirmar({
                title:           "Eliminar Producto",
                html:            "Se va a eliminar el producto indicado. <br />¿Estás seguro de que deseas continuar?",
                callbackConfirm: function () {
                    updatePedidoCantidad(id, 0);
                }
            });
        });

        $("button.btnSave").off("click").on("click", function (e) {
            e.preventDefault();
            $form.submit();
        });

        $("button.btnSend").off("click").on("click", function (e) {
            e.preventDefault();
            __confirmar({
                title:           "Enviar Pedido",
                html:            "Al enviar el pedido ya no se podrán añadir más productos ni podrá ser eliminado. <br />¿Estás seguro de que deseas enviarlo?",
                callbackConfirm: function () {
                    var total_pedido = __totalPedido();
                    if (total_pedido < Globals.MINIMO_PORTES_PAGADOS && Globals.ID_INTRANET === Globals.INTRANET_MAFERGA) {
                        setTimeout(function () {
                            __confirmar({
                                title:           "Enviar Pedido",
                                html:            "El importe mínimo para envío a portes pagados es de 150&euro;. ¿Deseas continuar con el envío del pedido?",
                                callbackConfirm: function () {
                                    $("input[name='id_estado']", $form).val(Globals.ESTADO_ENVIANDOSE);
                                    $form.submit();
                                }
                            });
                        }, 500);
                    } else {
                        $("input[name='id_estado']", $form).val(Globals.ESTADO_ENVIANDOSE);
                        $form.submit();
                    }
                }
            });
        });

        $("button.btnDel").off("click").on("click", function (e) {
            e.preventDefault();
            __confirmar({
                title:           "Eliminar Pedido",
                html:            "Se va a eliminar el pedido, por lo que los datos no se podrán recuperar. <br />¿Estás seguro de que deseas continuar?",
                callbackConfirm: function () {
                    $("input[name='accion']", $form).val("del");
                    $form.submit();
                }
            });
        });
    };

    var updatePedidoCantidad = function (id, cantidad) {
        $.ajax({
            type:     "POST",
            url:      Globals.HOST_INTRANET + "/pedidos_act.php",
            data:     {
                accion:   "updateCantidad",
                id:       id,
                cantidad: cantidad
            },
            dataType: "json",
            success:  function (json) {
                if (json.success) {
                    if (json.eliminarFila) {
                        $("tr[data-id='" + json.id + "']").fadeOut(function () {
                            $(this).remove();
                        });
                    } else {
                        $("input[name='precantidad_" + id + "']").val(json.precantidad);
                        $("td#subtotal_" + id).html(json.subtotal + " &euro;");
                    }
                    $("span.articulos").text(json.totalProds + " art.");
                    $("span.importe").html(json.totalPedido + " &euro;");
                    $("span.totalPedido").html(json.totalPedido + " &euro;");
                    $("span.subtotalPedido").html(json.subtotalPedido + " &euro;");
                    $("span.importeDescuentoFijo").html("-" + json.importe_descuento_fijo + " &euro;");
                    if (parseFloat(json.importe_descuento_variable) > 0) {
                        $("tr.descuentoVariable").show();
                        $("tr.msgDescuentoVariable").hide();
                    } else {
                        $("tr.descuentoVariable").hide();
                        $("tr.msgDescuentoVariable").show();
                    }
                    $("span.importeDescuentoVariable").html("-" + json.importe_descuento_variable + " &euro;");
                    $("span.descuentoVariable").html(json.descuento_variable + "%");
                    $("span.importeRestanteDescuento").html(json.importe_restante_descuento + " &euro;");
                    $("span.importePortes").html(json.importe_portes + " &euro;");
                    $("span.imprteRestantePortes").html(json.importe_restante_portes + " &euro;");
                    if (parseFloat(json.importe_restante_portes) > 0) {
                        $("tr.msgPortes, div.divPortes").show();
                        $("input[name='incluirPortes']").attr("disabled", false);
                    } else {
                        $("tr.msgPortes, div.divPortes").hide();
                        $("input[name='incluirPortes']").attr("disabled", true);
                    }
                    __notifica({
                        message: "Cantidad de productos modificada.",
                        status:  "success"
                    });
                } else {
                    __notifica({
                        message: json.msg
                    })
                }
            }
        });
    };

    var __handleToolTip = function () {
        $('[data-toggle="tooltip"]').tooltip();
    };

    var __handleRulesMethodsValidation = function () {
        $.validator.addMethod('filesize', function (value, element, param) {
            return this.optional(element) || (element.files[0].size <= param)
        });
    };

    /*var obtenerStocks = function (codigos, marcaFilas) {
     $.ajax({
     type:     "POST",
     url:      HOST_INTRANET + "/catalogo_act.php",
     data:     {
     accion: "dameStocks",
     codigo: codigos
     },
     dataType: "json",
     success:  function (json) {
     if (json.success) {
     if (marcaFilas == true) {
     $.each(json.productos, function (index, obj) {
     if (obj.stock == false) {
     $("tr.productRow[data-codigo='"+obj.codigoArt+"'] div.stock.nodisponible").fadeIn();
     } else {
     $("tr.productRow[data-codigo='"+obj.codigoArt+"'] div.stock.disponible").fadeIn();
     }
     });
     }
     }
     }
     });
     };*/

    var __handleDatepicker = function () {
        $('input.date-picker').datepicker({
            weekStart:       1,
            dateFormat:      'dd/mm/yy',
            autoclose:       true,
            language:        'es',
            dayNames:        ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
            dayNamesMin:     ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sá"],
            dayNamesShort:   ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
            monthNames:      ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
            monthNamesShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
            prevText:        "Anterior",
            nextText:        "Siguiente"
        });
    };

    var obtenerNetos = function (codigos, marcaPrecios) {
        var id_pedido = $("form#fPedido input[name='id_pedido']").val();
        $.ajax({
            type:     "POST",
            url:      Globals.HOST_INTRANET + "/catalogo_act.php",
            data:     {
                accion:    "dameNetos",
                codigo:    JSON.stringify(codigos),
                id_pedido: id_pedido
            },
            dataType: "json",
            success:  function (json) {
                if (json.success) {
                    $("small.noNetizado").fadeOut();
                    $("span.subtotalPedido").html(json.total + " &euro;");
                    $.each(json.productos, function (index, obj) {
                        var $td = $("td.precioNeto", $("tr[data-codigo='" + obj.codigoArt + "']"));
                        var $tdSubtotal = $("td.subtotal", $("tr[data-codigo='" + obj.codigoArt + "']"));
                        var cantidad = $("input[name^='cantidad_']", $("tr[data-codigo='" + obj.codigoArt + "']")).val();
                        var $trNetos = $("tr.netosRow[data-codigo='" + obj.codigoArt + "']");
                        var $divNetos = $("div.intervalo", $trNetos);
                        if (obj.obtenido == true) {
                            $td.html(obj.precioNeto + "&euro;");
                            var $subtotal = parseFloat(obj.precioNeto.replace(",", ".")) * parseInt(cantidad);
                            $tdSubtotal.html(number_format($subtotal, 2, ",", ".") + "&euro;");
                            if (typeof obj.intervaloNetos == "object") {
                                var $intervalos = obj.intervaloNetos;
                                var htmlNetos = "";
                                if ($intervalos.length > 1) {
                                    var cuenta = 0;
                                    var ud = "ud";
                                    var unidades = 0;
                                    $.each($intervalos, function (indice, intervalo) {
                                        unidades = intervalo["uds"];
                                        if (unidades == 0) {
                                            unidades = 1;
                                        }
                                        if (unidades > 1) {
                                            ud = "uds";
                                        }

                                        htmlNetos += unidades + " " + ud + ": <span style='font-weight: bold'>" + intervalo["precio"] + "</span>;&nbsp;&nbsp;&nbsp;";
                                        /*if (cuenta == 0) {
                                            htmlNetos += "menos de " + segundoValor["uds"] + " : <span style='font-weight: bold'>" + intervalo["precio"] + "</span>;&nbsp;&nbsp;&nbsp;";
                                        } else {
                                            htmlNetos += intervalo["uds"] + " o más: <span style='font-weight: bold'>" + intervalo["precio"] + "</span>;&nbsp;&nbsp;&nbsp;";
                                        }*/
                                        cuenta = cuenta + 1;
                                    });
                                    htmlNetos = htmlNetos.substr(0, htmlNetos.length - 19);
                                    $trNetos.show();
                                    $divNetos.html(htmlNetos);
                                }
                            }
                        } else {
                            $td.html("<i class='ion-alert'></i> 0,00 &euro;");
                            $("small.noNetizado").fadeIn();
                        }
                        $("tr.productRow[data-codigo='" + obj.codigoArt + "'] div.loading").hide();
                        if (obj.stock == false) {
                            $("tr.productRow[data-codigo='" + obj.codigoArt + "'] div.stock.nodisponible").fadeIn();
                        } else {
                            $("tr.productRow[data-codigo='" + obj.codigoArt + "'] div.stock.disponible").fadeIn();
                        }
                        $("div.alertLoading").fadeOut();
                    });
                }
            }
        });
    };


    var number_format = function (number, decimals, dec_point, thousands_sep) {
        number = (number + '')
            .replace(/[^0-9+\-Ee.]/g, '');
        var n          = !isFinite(+number) ? 0 : +number,
            prec       = !isFinite(+decimals) ? 0 : Math.abs(decimals),
            sep        = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
            dec        = (typeof dec_point === 'undefined') ? '.' : dec_point,
            s          = '',
            toFixedFix = function (n, prec) {
                var k = Math.pow(10, prec);
                return '' + (Math.round(n * k) / k)
                    .toFixed(prec);
            };
        // Fix for IE parseFloat(0.55).toFixed(0) = 0;
        s = (prec ? toFixedFix(n, prec) : '' + Math.round(n))
            .split('.');
        if (s[0].length > 3) {
            s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
        }
        if ((s[1] || '')
            .length < prec) {
            s[1] = s[1] || '';
            s[1] += new Array(prec - s[1].length + 1)
                .join('0');
        }
        return s.join(dec);
    };

    var __notifica = function (data) {
        var msg = data.message;
        var type = typeof (data.status) == "undefined" ? "warning" : data.status;
        var width = typeof (data.width) == "undefined" ? 500 : data.width;
        var marginLeft = (width / 2) * -1;

        var numNotifications = 0;
        var position = 0;
        var $lastNotificacion = $("div[id^='notificacion_']:last");
        if ($lastNotificacion.length > 0) {
            //numNotifications = parseInt($lastNotificacion.attr("id").replace("notificacion_", ""));
            numNotifications = parseInt($("div[id^='notificacion_']").length);
            position = numNotifications;
        }

        var nextNotificacion = numNotifications + 1;

        var html = '' +
            '<div id="notificacion_' + nextNotificacion + '" class="alert alert-' + type + ' alert-dismissible fade in notification" data-pos="' + position + '" role="alert" style="font-size: 16px; display: none; position: fixed;top: -100px;left: 50%;width: ' + width + 'px;margin-left: ' + marginLeft + 'px; z-index: 1060">' +
            '<button type="button" class="close closeNotificacion" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">×</span></button>' +
            msg +
            '</div>';

        var top = 50 + (position * 65);
        $(html).appendTo("body").show().animate({
            top: top
        }, 'normal', function () {
            setTimeout(function () {
                closeNotification($("div#notificacion_" + nextNotificacion));
            }, 3000);
        });

        $("button.closeNotificacion").off("click").on("click", function () {
            closeNotification($(this).parent());

        });

        var closeNotification = function ($obj) {
            $obj.animate({
                top: "-100px"
            }, 'normal', function () {
                $(this).remove();
                var newNotifications = 0;
                var newTop = 0;
                $("div.notification").each(function () {
                    newTop = 50 + (newNotifications * 65);
                    //$(this).attr("id", "notificacion_" + newNotifications);
                    newNotifications = newNotifications + 1;
                    $(this).animate({
                        top: newTop
                    });
                })
            });
        }
    };

    var __alertar = function (data) {
        var title = typeof (data.title) == "undefined" ? "Alerta" : data.title;
        var html = typeof (data.html) == "undefined" ? "" : data.html;

        var ModalHTML = '' +
            '<div class="modal fade" id="modal_alertar">' +
            '<div class="modal-dialog">' +
            '<div class="modal-content">' +
            '<div class="modal-header">' +
            '<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>' +
            '<h4 class="modal-title">' + title + '</h4>' +
            '</div>' +
            '<div class="modal-body">' + html + '</div>' +
            '<div class="modal-footer">' +
            '<button type="button" class="btn btn-primary" data-dismiss="modal">Aceptar</button>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>';

        $(ModalHTML).appendTo("body").modal('show');

        $('#modal_alertar').on('hidden.bs.modal', function (e) {
            $(this).remove();
            if (typeof data.callback == "function") {
                data.callback.call();
            }
        })
    };

    var __confirmar = function (data) {
        var title = typeof (data.title) == "undefined" ? "Alerta" : data.title;
        var html = typeof (data.html) == "undefined" ? "" : data.html;

        var ModalHTML = '' +
            '<div class="modal fade" id="modal_confirmar">' +
            '<div class="modal-dialog">' +
            '<div class="modal-content">' +
            '<div class="modal-header">' +
            '<button type="button" class="close btnCancel" aria-label="Close"><span aria-hidden="true">&times;</span></button>' +
            '<h4 class="modal-title">' + title + '</h4>' +
            '</div>' +
            '<div class="modal-body">' + html + '</div>' +
            '<div class="modal-footer">' +
            '<button type="button" class="btn btn-default btnCancel">Cancelar</button>' +
            '<button type="button" class="btn btn-primary btnConfirm">Aceptar</button>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>';

        $(ModalHTML).appendTo("body").modal({
            backdrop: 'static'
        }, 'show');

        var $modal = $("#modal_confirmar");

        $modal.on('hidden.bs.modal', function (e) {
            $(this).remove();
        });

        $("button.btnCancel", $modal).off("click").on("click", function () {
            if (typeof data.callbackCancel == "function") {
                data.callbackCancel.call();
            }
            $modal.modal("hide");
        });

        $("button.btnConfirm", $modal).off("click").on("click", function () {
            if (typeof data.callbackConfirm == "function") {
                data.callbackConfirm.call();
            }
            $modal.modal("hide");
        });
    };

    var __handleMenuNav = function () {
        $('nav#aside-menu').mmenu({
            extensions: ['effect-slide-menu'],
            counters:   true,
            navbar:     {}
        });
    };

    var __totalPedido = function () {
        var total = 0;
        $.ajax({
            type:    "POST",
            url:     Globals.HOST_INTRANET + "/pedidos_act.php",
            async:   false,
            data:    {
                accion: "precio_total"
            },
            success: function (data) {
                total = data;
            }
        });

        return total;
    };

    var __handleSearchClientes = function () {
        if ($("form#busqueda_clientes").length > 0) {
            $("a#search_clientes").off("click").on("click", function (e) {
                e.preventDefault();
                var cliente = $("input[name='search_cliente']").val();
                var poblacion = $("input[name='search_poblacion']").val();

                if (cliente == "" && poblacion == "") {
                    __alertar({
                        html: "Debe especificar un nombre y/o una población"
                    });
                } else {
                    $.ajax({
                        url:     Globals.HOST_INTRANET + "/clientes_act.php",
                        type:    "POST",
                        data:    {
                            accion:          "busqueda_clientes",
                            search_cliente:  cliente,
                            search_polacion: poblacion
                        },
                        success: function (data) {
                            if (json.success) {
                                var $modal_clientes = $("#modal_clientes");
                                if ($modal_clientes.length > 0) {
                                    $modal_clientes.remove();
                                }
                                $(json.content).appendTo("body").modal('show');
                            }
                        }
                    });
                }
            });
        }
    };

    var __handleSession = function () {
        var renueva_sesion = setInterval(function () {
            $.ajax({
                url:     Globals.HOST_INTRANET + "/renueva_sesion.php",
                data:    {
                    renueva_sesion: 0
                },
                success: function (res) {
                    if (res == "logout") {
                        location.href = Globals.HOST_INTRANET + "/logout.php"
                    }
                }
            })
        }, 10 * 60 * 1000); //cada 10 minutos (10 minutos * 60 segundos * 1000 milisegundos)
    };

    return {
        init: function () {
            init();
        },

        notifica: function (data) {
            __notifica(data);
        },

        alertar: function (data) {
            __alertar(data);
        },

        confirmar: function (data) {
            __confirmar(data);
        }
    }
}();